import { useEffect } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { agents } from "../data/agents";

// Lien court imprimé sur les QR codes : /c/mh → carte du mandataire avec les UTM de campagne.
export default function ShortCardRedirect() {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const agent = Object.values(agents).find((entry) => entry.shortCode === code?.toLowerCase());
  useEffect(() => {
    document.title = "Pimp My Place";
  }, []);
  if (!agent) return <Navigate to="/" replace />;
  const campaign = searchParams.get("c") || "networking";
  const target = `/${agent.slug}?utm_source=businesscard&utm_medium=qr&utm_campaign=${encodeURIComponent(campaign)}`;
  return <Navigate to={target} replace />;
}
